import { AppStatusIncidentSearch } from '@src/main/modules/app_status/domain/appStatusIncident.repository';

export const toAppStatusIncidentQueryParams = (
  criteria: AppStatusIncidentSearch,
): Record<string, boolean | number | string> => {
  const params: Record<string, boolean | number | string> = {
    limit: criteria.limit,
    offset: criteria.offset,
    sortField: criteria.sortField,
    sortOrder: criteria.sortOrder,
  };

  if (criteria.code) params.code = criteria.code;
  if (criteria.dateSince) params.dateSince = criteria.dateSince;
  if (criteria.dateUntil) params.dateUntil = criteria.dateUntil;
  if (criteria.severity) params.severity = criteria.severity;
  if (criteria.status) params.status = criteria.status;
  if (criteria.title) params.title = criteria.title;
  if (criteria.summary) params.summary = criteria.summary;
  if (criteria.errorDescription) params.errorDescription = criteria.errorDescription;
  if (criteria.possibleSolution) params.possibleSolution = criteria.possibleSolution;
  if (criteria.version) params.version = criteria.version;
  if (criteria.public !== null) params.public = criteria.public;
  if (criteria.visibleApp !== null) params.visibleApp = criteria.visibleApp;

  return params;
};
